import type { ReactNode } from 'react';
import { cn } from '../lib/cn';

type BadgeColor = 'navy' | 'gold' | 'green' | 'red' | 'gray' | 'amber';

interface BadgeProps {
  color?: BadgeColor;
  children: ReactNode;
  className?: string;
}

const colors: Record<BadgeColor, string> = {
  navy:  'bg-blue-100 text-blue-800',
  gold:  'bg-amber-100 text-amber-800',
  green: 'bg-green-100 text-green-800',
  red:   'bg-red-100 text-red-800',
  amber: 'bg-orange-100 text-orange-800',
  gray:  'bg-gray-100 text-gray-800',
};

export function Badge({ color = 'gray', children, className }: BadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-bold',
        colors[color],
        className,
      )}
    >
      {children}
    </span>
  );
}
